export function DangerousText({ children }) {
  const props = {
    dangerouslySetInnerHTML: { __html: `<span>${children}</span>` },
  };

  return <div className="[&>span]:block" {...props} />;
}
